import { Modal, Button, Input, Checkbox, message } from "antd";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axiosBaseURL from "../../api";

type LoginProps = {
  open: boolean;
  hideModal: () => void;
};

const Login: React.FC<LoginProps> = ({ open, hideModal }) => {
  const {
    login: signIn,
    user,
    signingIn,
    setUser,
  } = useAuth() as AuthContextValue;
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string | undefined>();
  const [userNameError, setUserNameError] = useState<string | undefined>();
  const [password, setPassword] = useState<string | undefined>();
  const [passwordError, setPasswordError] = useState<string | undefined>();
  const [captchaValue, setCaptchaValue] = useState(null);

  const location = useLocation().pathname.substring(1);

  const signin = async () => {
    const auth_str = "Basic " + window.btoa(userName + ":" + password);

    const result = await axiosBaseURL.get("/fe/login", {
      headers: { Authorization: auth_str },
    });
    const token = result.data.token;
    const userId = result.data.userId;

    if (token) {
      localStorage.setItem("token", `${userId}/${token}`);
    }
    return result;
  };

  const { data, refetch, error, isLoading, isFetching } = useQuery({
    staleTime: 10,
    enabled: false,
    queryKey: ["signin "],
    queryFn: signin,
  });

  useEffect(() => {
    if (data && data.data && data.data.roleId) {
      setUser(data.data);
    } else if (data && data.data && data.data.roleId === 0) {
      if (location === "") {
        message.error("Invalid credentials. Please try again.");
      }
    }
  }, [data]);

  useEffect(() => {
    if (user) {
      setTimeout(() => {
        if (user && user.roleName) {
          if (user.isFirstLogin === 1) {
            navigate("/changePassword?isFirstLogin=1");
          } else if (user.roleName === "ROLE_KFT_SUPER_ADMIN") {
            navigate("/admin");
          } else if (user.roleName === "ROLE_OFF_TAKER_ADMIN") {
            navigate("/off-taker");
          } else if (user.roleName === "BANK_ADMIN") {
            navigate("/bank");
          } else if (user.roleName === "INSURANCE_ADMIN") {
            navigate("/insurance");
          } else if (user.roleName === "ROLE_MPC_ADMIN") {
            navigate("/ad-dashboard");
          } else if (user.roleName === "ROLE_MPC_OPERATION") {
            navigate("/redemption");
          } else if (user.roleName === "ROLE_KFT_SP_ADMIN") {
            navigate("/admin");
          } else if (
            user.roleName === "ROLE_MFI_ADMIN" ||
            user.roleName === "ROLE_MFI_OPERATION"
          ) {
            navigate("/mfi");
          } else if (user.roleName === "ROLE_SUPER_ADMIN") {
            navigate("/sp-admin");
          }
        } else {
          // navigate('/redemption')
        }
      }, 1000);
    }
  }, [user]);

  const _logIn = () => {
    if (!userName) {
      setUserNameError("Invalid user name");
    }

    if (!password) {
      setPasswordError("Invalid password");
    }

    if (userName && password) {
      // signIn(userName, password);
      refetch();
    }
  };
  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          Welcome back
        </div>
      }
      open={open}
      centered
      onCancel={hideModal}
      closable
      footer={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* || !captchaValue */}
          <Button
            loading={isLoading || isFetching}
            disabled={isLoading || isFetching}
            type="primary"
            style={{ width: "100%", height: 54 }}
            onClick={_logIn}
          >
            Login
          </Button>
          <div />
          <div style={{ display: "flex", gap: 12, marginTop: 10 }}>
            {/* <span style={{ color: '#C4C4C4', fontWeight: 500, fontSize: 16 }}>Don't have an account</span>
            <span style={{ color: '#009602', fontWeight: 500, fontSize: 16 }}>Create account</span> */}
          </div>
        </div>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", marginTop: 50 }}>
        <Input
          value={userName}
          onChange={(e) => {
            setUserName(e.target.value);
            setUserNameError(undefined);
          }}
          addonBefore={
            <div style={{ width: 75, fontWeight: 500, fontSize: 15 }}>
              Username
            </div>
          }
          placeholder="Enter user name"
        />
        {userNameError && <div style={{ color: "red" }}>{userNameError}</div>}
        <Input.Password
          style={{ marginTop: 31 }}
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setPasswordError(undefined);
          }}
          addonBefore={
            <div style={{ width: 75, fontWeight: 500, fontSize: 15 }}>
              Password
            </div>
          }
          placeholder="Your password"
        />
        {/* {process.env.REACT_APP_RECAPTCHA_SITE_KEY && ( */}
        {/* <ReCAPTCHA
          style={{ marginTop: 20, alignItems: "center" }}
          sitekey={"6LdZRp8qAAAAAPIwhObOgWqvZidvBwilMLGPK_hw"}
          // sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          onChange={(token: any) => setCaptchaValue(token)}
        /> */}
        {/* )} */}
        {passwordError && <div style={{ color: "red" }}>{passwordError}</div>}
        {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', gap: 13, color: '#4F4F4f', fontWeight: 400, fontSize: 16 }}>
                        <Checkbox />
                        Remember me
                    </div>
                    <div style={{ color: '#009692', fontWeight: 500, fontSize: 16 }}>Forgot password?</div>
                </div> */}
      </div>
    </Modal>
  );
};

export default Login;
